export default __webpack_public_path__ + "static/media/backgroundImg.9f7d119c.png";